<template>
  <div>
    
    <router-view></router-view>
    <div class="fixed bottom-52 left-40 layer_down">
      <i class="add_on text-3xl fas fa-plus animate-spin"></i>
    </div>
    <div class="fixed top-36 lg:top-52 right-40 layer_down">
      <i class="add_on text-3xl fas fa-plus animate-spin"></i>
    </div>
    <div class="fixed top-60 left-96 layer_down">
      <i class="add_on text-3xl fas fa-plus animate-spin"></i>
    </div>
  </div>
</template>

<script>
import Master from  '@/Master/master.vue'

import AOS from "aos";

export default {
  name: "App",
  components: {
    Master
  },
  data() {
    return {
      isDarkMood: true,
    };
  },
  created() {
    AOS.init();
    let darkMode = localStorage.getItem("darkMode");
    if (darkMode == "true" || darkMode == null) {
      if (darkMode == null) {
        this.isDarkMood = true;
        localStorage.setItem("darkMode", false);
      }
      if (darkMode == "true") {
        document.body.style.backgroundColor = "rgba(255 , 255, 255, 0.4)";
        this.isDarkMood = false;
      }
    } else if (darkMode == "false") {
      this.isDarkMood = true;
    }
  },
  
};
</script>
<style>
.active {
  color: rgb(59, 130, 246) !important;
  transition: color 0.8 ease;
}
.active_blogs_cate {
  color: rgb(89, 75, 221) !important;
  text-decoration: underline;
  font-weight: bolder;
  transition: color font-weight 0.8 ease;
}
.layer_down {
  z-index: -1;
}
body {
  background-color: #151b3c;
  font-family: "Poppins", sans-serif;
  transition: background-color 1s;
}

.text-logo {
  color: #3e4fb0;
}

.icon_color {
  color: #a9b1e1;
}

.menu_bar_bg {
  background-color: rgba(50, 55, 79, 0.4);
  backdrop-filter: blur(3px);
  /* transition : background-color 1s; */
}
.dark_menu_bar_bg {
  backdrop-filter: blur(8px);
  box-shadow: 0 2px 4px rgba(50, 55, 79, 0.4);
  transition: background-color 1s;
}
.hi {
  color: #3e4fb0;
}
.exp {
  color: #5263c2;
}
.music_wave,
.music {
  background-color: #293576;
}
.music_wave {
  transform-origin: center;
  animation: ani 1s linear alternate-reverse infinite;
}
.wave {
  align-items: flex-end;
}

@keyframes ani {
  0% {
    transform-origin: center;
    height: 0rem;
  }
  20% {
    transform-origin: center;
    height: 1.4rem;
  }
  50% {
    transform-origin: center;
    height: 2rem;
  }
  70% {
    transform-origin: center;
    height: 2.5rem;
  }
  100% {
    transform-origin: center;
    height: 3rem;
  }
}

.music_wave:nth-child(1) {
  animation-delay: 0s;
}
.music_wave:nth-child(2) {
  animation-delay: 0.2s;
}
.music_wave:nth-child(3) {
  animation-delay: 0.1s;
}
.music_wave:nth-child(4) {
  animation-delay: 0.8s;
}
.music_wave:nth-child(5) {
  animation-delay: 0.3s;
}
.music_wave:nth-child(6) {
  animation-delay: 0.2s;
}
.music_wave:nth-child(7) {
  animation-delay: 0.8;
}
.music_wave:nth-child(8) {
  animation-delay: 0.2s;
}
.music_wave:nth-child(9) {
  animation-delay: 0.8s;
}
.music_wave:nth-child(10) {
  animation-delay: 0.2s;
}
.music_wave:nth-child(11) {
  animation-delay: 0.11s;
}
.music_wave:nth-child(12) {
  animation-delay: 0.5s;
}
.music_wave:nth-child(13) {
  animation-delay: 0.8s;
}
.music_wave:nth-child(14) {
  animation-delay: 0.5s;
}
.music_wave:nth-child(15) {
  animation-delay: 0.2s;
}
.music_wave:nth-child(16) {
  animation-delay: 0.5s;
}
.music_wave:nth-child(17) {
  animation-delay: 0.3s;
}
.music_wave:nth-child(18) {
  animation-delay: 1s;
}
.music_wave:nth-child(19) {
  animation-delay: 0.7s;
}
.music_wave:nth-child(20) {
  animation-delay: 0.2s;
}
.music_wave:nth-child(21) {
  animation-delay: 1s;
}

.download_cv {
  border: 2px solid #6f7dcc;
  color: #6f7dcc;
}
.about_me_btn {
  background-color: #6f7dcc;
  color: #151b3c;
}
.tools {
  background-color: #293576;
}

.bg_skills {
  background-color: #5263c2;
  color: #151b3c;
}

.seeMore:hover .see_more_cta {
  color: blue;
  transform: translateX(0.25rem);
}

.seeMore:hover span {
  color: blue;
}

.model {
  background-color: rgba(71, 71, 71, 0.7);
}
.model_content {
  background-color: #131937;
}
.md__box {
  transition: opacity 0.5s;
}

.swiper_rounded {
  border-radius: 1rem;
}

::-webkit-scrollbar {
  width: 0.6rem;
  border-radius: 0.2rem;
  background-color: #a9b1e1;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(50, 55, 79, 0.7);
  border-radius: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgb(50, 55, 79);
}

.add_on {
  color: rgba(41, 53, 118, 0.5);
}


/* sun animation */
.jello-horizontal {
	-webkit-animation: jello-horizontal 0.9s both;
	        animation: jello-horizontal 0.9s both;
}

@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
            transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
            transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
            transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
            transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
            transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
            transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
            transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
            transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
            transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
            transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
            transform: scale3d(1, 1, 1);
  }
}

</style>
